import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import GridBg from "@/components/GridBg";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Archetypes from "@/pages/Archetypes";
import RecordHolders from "@/pages/RecordHolders";
import Events from "@/pages/Events";
import EventLeaderboard from "@/pages/EventLeaderboard";
import Leaderboard from "@/pages/Leaderboard";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MyGPS from "@/pages/MyGPS";
import ArchetypeDetail from "@/pages/ArchetypeDetail";
import TestDetail from "@/pages/TestDetail";
import Tests from "@/pages/Tests";
import Admin from "@/pages/Admin";
import ForgotPassword from "@/pages/ForgotPassword";
import VolunteerScoring from "@/pages/VolunteerScoring";

import "@/App.css";

export default function App() {
  return (
    <div className="App relative min-h-screen">
      <GridBg />
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <main className="relative z-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/archetypes" element={<Archetypes />} />
              <Route path="/archetypes/:code" element={<ArchetypeDetail />} />
              <Route path="/tests" element={<Tests />} />
              <Route path="/tests/:key" element={<TestDetail />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/record-holders" element={<RecordHolders />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:eventId/leaderboard" element={<EventLeaderboard />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/my-gps"
                element={<ProtectedRoute><MyGPS /></ProtectedRoute>}
              />
              <Route
                path="/volunteer"
                element={<ProtectedRoute><VolunteerScoring /></ProtectedRoute>}
              />
            </Routes>
          </main>
          <Footer />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "rgba(10,14,22,0.9)", border: "1px solid rgba(0,240,255,0.35)", color: "#fff", fontFamily: "JetBrains Mono, monospace", fontSize: "12px", letterSpacing: "0.1em" } }} />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
